import React, { useState, useEffect } from 'react';
import { supabase } from '../supabase';
import axios from 'axios';

const API = 'https://app.recensement-enfantsnonproteges.fr';

const DEPARTEMENTS = ['01 – Ain','02 – Aisne','03 – Allier','04 – Alpes-de-Haute-Provence','05 – Hautes-Alpes','06 – Alpes-Maritimes','07 – Ardèche','08 – Ardennes','09 – Ariège','10 – Aube','11 – Aude','12 – Aveyron','13 – Bouches-du-Rhône','14 – Calvados','15 – Cantal','16 – Charente','17 – Charente-Maritime','18 – Cher','19 – Corrèze','21 – Côte-d\'Or','22 – Côtes-d\'Armor','23 – Creuse','24 – Dordogne','25 – Doubs','26 – Drôme','27 – Eure','28 – Eure-et-Loir','29 – Finistère','30 – Gard','31 – Haute-Garonne','32 – Gers','33 – Gironde','34 – Hérault','35 – Ille-et-Vilaine','36 – Indre','37 – Indre-et-Loire','38 – Isère','39 – Jura','40 – Landes','41 – Loir-et-Cher','42 – Loire','43 – Haute-Loire','44 – Loire-Atlantique','45 – Loiret','46 – Lot','47 – Lot-et-Garonne','48 – Lozère','49 – Maine-et-Loire','50 – Manche','51 – Marne','52 – Haute-Marne','53 – Mayenne','54 – Meurthe-et-Moselle','55 – Meuse','56 – Morbihan','57 – Moselle','58 – Nièvre','59 – Nord','60 – Oise','61 – Orne','62 – Pas-de-Calais','63 – Puy-de-Dôme','64 – Pyrénées-Atlantiques','65 – Hautes-Pyrénées','66 – Pyrénées-Orientales','67 – Bas-Rhin','68 – Haut-Rhin','69 – Rhône','70 – Haute-Saône','71 – Saône-et-Loire','72 – Sarthe','73 – Savoie','74 – Haute-Savoie','75 – Paris','76 – Seine-Maritime','77 – Seine-et-Marne','78 – Yvelines','79 – Deux-Sèvres','80 – Somme','81 – Tarn','82 – Tarn-et-Garonne','83 – Var','84 – Vaucluse','85 – Vendée','86 – Vienne','87 – Haute-Vienne','88 – Vosges','89 – Yonne','90 – Territoire de Belfort','91 – Essonne','92 – Hauts-de-Seine','93 – Seine-Saint-Denis','94 – Val-de-Marne','95 – Val-d\'Oise','971 – Guadeloupe','972 – Martinique','973 – Guyane','974 – La Réunion','976 – Mayotte'];
const INSTANCES = ['1ère Instance','Appel','Cassation','CEDH'];
const GARDES = ['Garde complète','Garde alternée','Droit de visite','Visite médiatisée','Appel téléphonique uniquement','Rien (aucune garde, aucune visite, aucun appel)'];
const VIOLENCES = ['Viols','Agressions sexuelles','Violences physiques','Contrôle coercitif','Violence institutionnelle'];
const TYPES_PLAINTE = ['IP (Information préoccupante)','Signalement','Plainte police','Plainte avec CPC'];
const ETATS_PLAINTE = ['CSS (Classement sans suite)','Non-lieu','Acquittement','Relaxe','Condamné'];
const ASE_TYPES = ['Foyer','Famille d\'accueil','AEMO','MIJ','AED'];
const RAISONS = ['Aliénation parentale','Surprotection','Conflit parental','Conflit de loyauté','Autre'];
const RAISONS_RENONCEMENT = ['La police a refusé ma plainte','L\'avocat m\'a déconseillé','Manque de moyens financiers','Procédure bâillon devant le JAF','Obligation du lien père/enfant','Violences psychologiques difficiles à prouver','Maman en fuite','Autres'];
const PAR_QUI = ['JAF','Procureur','Autre'];
const STEPS = ['Parent protecteur','Juridiction','Enfants','Violences','Garde','Procédure','Données dossier','Témoignage & Actions'];

const Toggle = ({ value, onChange, label }) => (
  <div className="toggle-row">
    <span className="tl">{label}</span>
    <button className={`tog${value?' on':''}`} onClick={() => onChange(!value)}><div className="tog-t"></div></button>
  </div>
);

const ANON = () => (
  <div className="anon-reminder">⚠ Initiales uniquement pour tous les noms (y compris l'agresseur).</div>
);

function MagicLinkForm() {
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const sendCode = async () => {
    if (!email) return;
    setLoading(true); setError('');
    const { error } = await supabase.auth.signInWithOtp({ email, options: { shouldCreateUser: true } });
    if (error) { setError('Erreur lors de l\'envoi. Réessayez.'); }
    else { setSent(true); }
    setLoading(false);
  };

  const verifyCode = async () => {
    if (!code) return;
    setLoading(true); setError('');
    const { error } = await supabase.auth.verifyOtp({ email, token: code, type: 'email' });
    if (error) { setError('Code incorrect ou expiré. Réessayez.'); }
    setLoading(false);
  };

  if (sent) return (
    <div>
      <div style={{textAlign:'center',marginBottom:'20px'}}>
        <div style={{fontSize:'32px',marginBottom:'8px'}}>📧</div>
        <div style={{fontSize:'14px',fontWeight:'700',color:'#0a1f44',marginBottom:'4px'}}>Code envoyé à {email}</div>
        <div style={{fontSize:'12px',color:'#888'}}>Vérifiez vos emails (et vos spams).</div>
      </div>
      <div className="field">
        <label className="lbl req">Code à 6 chiffres</label>
        <input type="text" maxLength="6" value={code} onChange={e=>setCode(e.target.value.replace(/\D/,''))} onKeyDown={e=>e.key==='Enter'&&verifyCode()} placeholder="123456" style={{fontSize:'24px',letterSpacing:'0.3em',textAlign:'center'}} />
      </div>
      {error && <div style={{color:'#e24b4a',fontSize:'12px',marginBottom:'8px'}}>{error}</div>}
      <button className="btn-blue" style={{width:'100%',marginTop:'8px'}} onClick={verifyCode} disabled={loading||code.length<6}>
        {loading?'Vérification…':'Me connecter →'}
      </button>
      <button style={{width:'100%',marginTop:'8px',background:'transparent',border:'none',color:'#888',fontSize:'12px',cursor:'pointer'}} onClick={()=>{setSent(false);setCode('');setError('');}}>
        ← Changer d'email
      </button>
    </div>
  );

  return (
    <div>
      <div className="field"><label className="lbl req">Votre email</label>
        <input type="email" value={email} onChange={e=>setEmail(e.target.value)} onKeyDown={e=>e.key==='Enter'&&sendCode()} placeholder="votre@email.fr" />
      </div>
      {error && <div style={{color:'#e24b4a',fontSize:'12px',marginBottom:'8px'}}>{error}</div>}
      <button className="btn-blue" style={{width:'100%',marginTop:'8px'}} onClick={sendCode} disabled={loading||!email}>
        {loading?'Envoi…':'Accéder à mon espace →'}
      </button>
      <p style={{fontSize:'11px',color:'#aaa',marginTop:'12px',textAlign:'center'}}>Un code à 6 chiffres sera envoyé à votre adresse email.</p>
    </div>
  );
}

function DossierForm({ token, userId, draft, onSubmitted }) {
  const [step, setStep] = useState(0);
  const [saving, setSaving] = useState(false);
  const [saveMsg, setSaveMsg] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const [form, setForm] = useState({
    pp_prenom:'', pp_nom:'', pp_tel:'', pp_email:'', pp_public:true,
    type_violences:[],
    etat_plainte:'IP (Information préoccupante)', etat_plainte_agresseur:'', etat_plainte_pp:'',
    raison_invoquee:'Aliénation parentale', raison_invoquee_autre:'',
    nb_plaintes_pp:'', nb_condamnations_pp:'',
    cout_financier:'', cout_medical:'', cout_professionnel:'',
    remarque_procedure:'', parole_enfant_seulement:false,
    renoncement_procedure:false, raisons_renoncement:[],
    nb_preuves:'', nb_personnes_protectrices:'', nb_magistrats:'',
    nb_agents_ase:'', nb_dossier_perdu:'', nb_jugements:'',
    nb_dysfonctionnements:'', nb_enfant_a_parle:'',
    temoignage:'', cgu_acceptees:false,
    action_anonyme_collectif:false, action_nominatif_collectif:false,
    action_collectif_contact:false, temoignage_journaliste_anon:false,
    temoignage_journaliste_nominatif:false,
  });
  const [enfants, setEnfants] = useState([{prenom:'',nom:'',date_naissance:'',nom_masque:true,garde_pp:'',protege:false,protege_mois:'',protege_par:[]}]);
  const [tribunaux, setTribunaux] = useState([{instance:'1ère Instance',ville:'',departement:'',nb_fois:'1'}]);
  const [gardes, setGardes] = useState([{garde_agresseur:'Garde complète',garde_pp:'Visite médiatisée',ase_impliquee:false,ase_type:'',type_violence:'',date_debut:'',date_denonciation:'',date_fin:''}]);
  const [plaintes, setPlaintes] = useState([{type_plainte:'',nombre:'',etat:''}]);

  useEffect(() => {
    if (draft) {
      setForm(f => ({...f,
        pp_prenom:draft.pp_prenom||'', pp_nom:draft.pp_nom||'', pp_tel:draft.pp_tel||'', pp_email:draft.pp_email||'',
        pp_public:draft.pp_public!==null?draft.pp_public:true,
        type_violences:draft.type_violences||[],
        etat_plainte:draft.etat_plainte||'IP (Information préoccupante)',
        raison_invoquee:draft.raison_invoquee||'Aliénation parentale',
        temoignage:draft.temoignage||'',
        cout_financier:draft.cout_financier||'', cout_medical:draft.cout_medical||'', cout_professionnel:draft.cout_professionnel||'',
        nb_preuves:draft.nb_preuves||'', nb_magistrats:draft.nb_magistrats||'',
        nb_jugements:draft.nb_jugements||'', nb_dysfonctionnements:draft.nb_dysfonctionnements||'',
        nb_enfant_a_parle:draft.nb_enfant_a_parle||'', nb_agents_ase:draft.nb_agents_ase||'',
        nb_dossier_perdu:draft.nb_dossier_perdu||'', nb_plaintes_pp:draft.nb_plaintes_pp||'',
        nb_condamnations_pp:draft.nb_condamnations_pp||'', remarque_procedure:draft.remarque_procedure||'',
      }));
      if (draft.enfants?.length) setEnfants(draft.enfants);
      if (draft.tribunaux?.length) setTribunaux(draft.tribunaux);
      if (draft.gardes?.length) setGardes(draft.gardes);
      if (draft.plaintes?.length) setPlaintes(draft.plaintes);
    }
  }, [draft]);

  const set = (k,v) => setForm(f=>({...f,[k]:v}));
  const toggleV = v => set('type_violences', form.type_violences.includes(v)?form.type_violences.filter(x=>x!==v):[...form.type_violences,v]);
  const toggleR = v => set('raisons_renoncement', form.raisons_renoncement.includes(v)?form.raisons_renoncement.filter(x=>x!==v):[...form.raisons_renoncement,v]);
  const setE = (i,k,v) => setEnfants(e=>e.map((en,idx)=>idx===i?{...en,[k]:v}:en));
  const setEP = (i,v) => setEnfants(e=>e.map((en,idx)=>idx===i?{...en,protege_par:en.protege_par.includes(v)?en.protege_par.filter(x=>x!==v):[...en.protege_par,v]}:en));
  const setT = (i,k,v) => setTribunaux(t=>t.map((tr,idx)=>idx===i?{...tr,[k]:v}:tr));
  const setG = (i,k,v) => setGardes(g=>g.map((gr,idx)=>idx===i?{...gr,[k]:v}:gr));
  const setP = (i,k,v) => setPlaintes(p=>p.map((pl,idx)=>idx===i?{...pl,[k]:v}:pl));

  const save = async () => {
    setSaving(true); setSaveMsg('');
    try {
      await axios.post(API+'/api/fiches/draft', {...form, enfants, tribunaux, gardes, plaintes, supabase_user_id:userId}, { headers:{Authorization:'Bearer '+token} });
      setSaveMsg('✓ Sauvegardé');
      setTimeout(()=>setSaveMsg(''), 3000);
    } catch(e) { setSaveMsg('Erreur de sauvegarde'); }
    setSaving(false);
  };

  const submit = async () => {
    if (!form.cgu_acceptees) { setError('Acceptez les CGU avant d\'envoyer.'); return; }
    setSubmitting(true); setError('');
    try {
      const payload = {...form, enfants, tribunaux, gardes, plaintes, supabase_user_id:userId, est_brouillon:false, statut:'en_attente'};
      await axios.post(API+'/api/fiches', payload, { headers:{Authorization:'Bearer '+token} });
      onSubmitted();
    } catch(e) { setError('Erreur lors de l\'envoi.'); }
    setSubmitting(false);
  };

  const SaveBtn = () => (
    <button onClick={save} disabled={saving} style={{background:'#fff',color:'#1a7fd4',border:'2px solid #1a7fd4',borderRadius:'7px',padding:'8px 20px',fontSize:'13px',fontWeight:'700',cursor:'pointer'}}>
      {saving?'Sauvegarde…':saveMsg||'Sauvegarder'}
    </button>
  );

  return (
    <div>
      <div style={{background:'#f4f6fb',padding:'16px 0',marginBottom:'16px'}}>
        <div className="step-pills" style={{padding:'0 24px'}}>
          {STEPS.map((s,i)=>(
            <button key={i} className={`sp${step===i?' active':step>i?' done':''}`} onClick={()=>setStep(i)}>
              <span className="sp-n">{step>i?'✓':i+1}</span>{s}
            </button>
          ))}
        </div>
      </div>

      <div style={{padding:'0 24px'}}>

        {/* ÉTAPE 1 */}
        <div className={`step-block${step===0?' show':''}`}>
          <div className="step-title">Parent protecteur</div>
          <div className="note-blue">Vos coordonnées sont transmises au collectif uniquement — jamais publiées.</div>
          <div className="col2">
            <div className="field"><label className="lbl req">Prénom</label><input type="text" value={form.pp_prenom} onChange={e=>set('pp_prenom',e.target.value)} /></div>
            <div className="field"><label className="lbl req">Nom</label><input type="text" value={form.pp_nom} onChange={e=>set('pp_nom',e.target.value)} /></div>
          </div>
          <div className="col2">
            <div className="field"><label className="lbl req">Téléphone</label><input type="tel" value={form.pp_tel} onChange={e=>set('pp_tel',e.target.value)} /></div>
            <div className="field"><label className="lbl req">Email</label><input type="email" value={form.pp_email} onChange={e=>set('pp_email',e.target.value)} /></div>
          </div>
          <Toggle value={form.pp_public} onChange={v=>set('pp_public',v)} label="Afficher mon prénom et nom publiquement sur la fiche" />
          <div className="nav-btns"><SaveBtn /><button className="btn-next" onClick={()=>setStep(1)}>Suivant →</button></div>
        </div>

        {/* ÉTAPE 2 */}
        <div className={`step-block${step===1?' show':''}`}>
          <div className="step-title">Juridiction</div>
          <ANON />
          {tribunaux.map((tr,i)=>(
            <div key={i} className="child-card">
              <div className="child-card-t">Tribunal {i+1}</div>
              <div className="col2">
                <div className="field"><label className="lbl">Instance</label>
                  <select value={tr.instance} onChange={e=>setT(i,'instance',e.target.value)}>{INSTANCES.map(o=><option key={o}>{o}</option>)}</select>
                </div>
                <div className="field"><label className="lbl">Ville</label><input type="text" value={tr.ville} onChange={e=>setT(i,'ville',e.target.value)} placeholder="ex. Bobigny…" /></div>
              </div>
              <div className="col2">
                <div className="field"><label className="lbl">Département</label>
                  <select value={tr.departement} onChange={e=>setT(i,'departement',e.target.value)}>
                    <option value="">Sélectionner…</option>
                    {DEPARTEMENTS.map(d=><option key={d} value={d}>{d}</option>)}
                  </select>
                </div>
                <div className="field"><label className="lbl">Nombre de fois</label>
                  <input type="number" min="1" value={tr.nb_fois} onChange={e=>setT(i,'nb_fois',e.target.value)} style={{width:'80px'}} />
                </div>
              </div>
            </div>
          ))}
          <button className="add-child" onClick={()=>setTribunaux(t=>[...t,{instance:'1ère Instance',ville:'',departement:'',nb_fois:'1'}])}>+ Ajouter un tribunal</button>
          <div style={{marginTop:'16px',padding:'14px',background:'#fef2f2',borderRadius:'8px',border:'1px solid #fecaca'}}>
            <Toggle value={form.renoncement_procedure} onChange={v=>set('renoncement_procedure',v)} label="Je n'ai pas pu passer devant un tribunal ou déposer plainte" />
            {form.renoncement_procedure && (
              <div className="cb-group" style={{marginTop:'10px'}}>
                {RAISONS_RENONCEMENT.map(r=><label key={r} className="cb-item"><input type="checkbox" checked={form.raisons_renoncement.includes(r)} onChange={()=>toggleR(r)} />{r}</label>)}
              </div>
            )}
          </div>
          <div className="nav-btns"><SaveBtn /><div style={{display:'flex',gap:'8px'}}><button className="btn-prev" onClick={()=>setStep(0)}>← Précédent</button><button className="btn-next" onClick={()=>setStep(2)}>Suivant →</button></div></div>
        </div>

        {/* ÉTAPE 3 */}
        <div className={`step-block${step===2?' show':''}`}>
          <div className="step-title">Enfants concernés</div>
          <div className="note-blue">Les noms et prénoms des enfants ne sont jamais affichés publiquement.</div>
          {enfants.map((en,i)=>(
            <div key={i} className="child-card">
              <div className="child-card-t">Enfant {i+1}</div>
              <div className="col2">
                <div className="field"><label className="lbl req">Prénom</label><input type="text" value={en.prenom} onChange={e=>setE(i,'prenom',e.target.value)} /></div>
                <div className="field"><label className="lbl req">Nom</label><input type="text" value={en.nom} onChange={e=>setE(i,'nom',e.target.value)} /></div>
              </div>
              <div className="col2">
                <div className="field"><label className="lbl req">Date de naissance</label><input type="date" value={en.date_naissance} onChange={e=>setE(i,'date_naissance',e.target.value)} /></div>
                <div className="field"><label className="lbl">Mode de garde actuel — parent protecteur</label>
                  <select value={en.garde_pp} onChange={e=>setE(i,'garde_pp',e.target.value)}>
                    <option value="">Sélectionner…</option>{GARDES.map(o=><option key={o}>{o}</option>)}
                  </select>
                </div>
              </div>
              <Toggle value={en.protege} onChange={v=>setE(i,'protege',v)} label="L'enfant a finalement été protégé" />
              {en.protege && (
                <div className="col2">
                  <div className="field"><label className="lbl">Après combien de mois ?</label><input type="number" min="0" value={en.protege_mois} onChange={e=>setE(i,'protege_mois',e.target.value)} placeholder="0" /></div>
                  <div className="field"><label className="lbl">Par qui ?</label>
                    <div style={{display:'flex',gap:'12px',marginTop:'4px',flexWrap:'wrap'}}>
                      {PAR_QUI.map(p=><label key={p} className="cb-item"><input type="checkbox" checked={en.protege_par.includes(p)} onChange={()=>setEP(i,p)} />{p}</label>)}
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}
          <button className="add-child" onClick={()=>setEnfants(e=>[...e,{prenom:'',nom:'',date_naissance:'',nom_masque:true,garde_pp:'',protege:false,protege_mois:'',protege_par:[]}])}>+ Ajouter un enfant</button>
          <div className="nav-btns"><SaveBtn /><div style={{display:'flex',gap:'8px'}}><button className="btn-prev" onClick={()=>setStep(1)}>← Précédent</button><button className="btn-next" onClick={()=>setStep(3)}>Suivant →</button></div></div>
        </div>

        {/* ÉTAPE 4 */}
        <div className={`step-block${step===3?' show':''}`}>
          <div className="step-title">Type de violences</div>
          <ANON />
          <div className="cb-group">
            {VIOLENCES.map(v=><label key={v} className="cb-item"><input type="checkbox" checked={form.type_violences.includes(v)} onChange={()=>toggleV(v)} />{v}</label>)}
            <label className="cb-item dim"><input type="checkbox" disabled /> Placement ASE illégal <span className="soon">à venir</span></label>
            <label className="cb-item dim"><input type="checkbox" disabled /> Prostitution via ASE <span className="soon">à venir</span></label>
          </div>
          <div className="nav-btns"><SaveBtn /><div style={{display:'flex',gap:'8px'}}><button className="btn-prev" onClick={()=>setStep(2)}>← Précédent</button><button className="btn-next" onClick={()=>setStep(4)}>Suivant →</button></div></div>
        </div>

        {/* ÉTAPE 5 */}
        <div className={`step-block${step===4?' show':''}`}>
          <div className="step-title">Situation de garde</div>
          <ANON />
          {gardes.map((g,i)=>(
            <div key={i} className="child-card">
              <div className="child-card-t">Période {i+1}</div>
              <div className="col2">
                <div className="field"><label className="lbl">Garde — parent agresseur</label>
                  <select value={g.garde_agresseur} onChange={e=>setG(i,'garde_agresseur',e.target.value)}>{GARDES.map(o=><option key={o}>{o}</option>)}</select>
                </div>
                <div className="field"><label className="lbl">Garde — parent protecteur</label>
                  <select value={g.garde_pp} onChange={e=>setG(i,'garde_pp',e.target.value)}>{[...GARDES].reverse().map(o=><option key={o}>{o}</option>)}</select>
                </div>
              </div>
              <div className="col2">
                <div className="field"><label className="lbl">ASE durant cette période</label>
                  <select value={g.ase_impliquee} onChange={e=>setG(i,'ase_impliquee',e.target.value==='true')}>
                    <option value="false">Non</option><option value="true">Oui</option>
                  </select>
                </div>
                {g.ase_impliquee && <div className="field"><label className="lbl">Type ASE</label>
                  <select value={g.ase_type} onChange={e=>setG(i,'ase_type',e.target.value)}>
                    <option value="">Sélectionner…</option>{ASE_TYPES.map(o=><option key={o}>{o}</option>)}
                  </select>
                </div>}
              </div>
              <div className="field"><label className="lbl">Type de violence durant cette période</label>
                <select value={g.type_violence} onChange={e=>setG(i,'type_violence',e.target.value)}>
                  <option value="">Sélectionner…</option>{VIOLENCES.map(o=><option key={o}>{o}</option>)}
                </select>
              </div>
              <div className="col3">
                <div className="field"><label className="lbl">Date début</label><input type="date" value={g.date_debut} onChange={e=>setG(i,'date_debut',e.target.value)} /></div>
                <div className="field"><label className="lbl">Date dénonciation</label><input type="date" value={g.date_denonciation} onChange={e=>setG(i,'date_denonciation',e.target.value)} /></div>
                <div className="field"><label className="lbl">Date fin</label><input type="date" value={g.date_fin} onChange={e=>setG(i,'date_fin',e.target.value)} /></div>
              </div>
            </div>
          ))}
          <button className="add-child" onClick={()=>setGardes(g=>[...g,{garde_agresseur:'Garde complète',garde_pp:'Visite médiatisée',ase_impliquee:false,ase_type:'',type_violence:'',date_debut:'',date_denonciation:'',date_fin:''}])}>+ Ajouter une période</button>
          <div className="nav-btns"><SaveBtn /><div style={{display:'flex',gap:'8px'}}><button className="btn-prev" onClick={()=>setStep(3)}>← Précédent</button><button className="btn-next" onClick={()=>setStep(5)}>Suivant →</button></div></div>
        </div>

        {/* ÉTAPE 6 */}
        <div className={`step-block${step===5?' show':''}`}>
          <div className="step-title">État de la procédure</div>
          <ANON />
          <div style={{background:'#fef2f2',border:'1px solid #fecaca',borderRadius:'10px',padding:'16px',marginBottom:'16px'}}>
            <div style={{fontSize:'13px',fontWeight:'700',color:'#991b1b',marginBottom:'12px',textTransform:'uppercase'}}>Procédure contre l'agresseur</div>
            <div className="col3">
              <div className="field"><label className="lbl">Type de plainte</label>
                <select value={form.etat_plainte} onChange={e=>set('etat_plainte',e.target.value)}>{TYPES_PLAINTE.map(o=><option key={o}>{o}</option>)}</select>
              </div>
              <div className="field"><label className="lbl">État actuel</label>
                <select value={form.etat_plainte_agresseur} onChange={e=>set('etat_plainte_agresseur',e.target.value)}>
                  <option value="">Sélectionner…</option>{ETATS_PLAINTE.map(o=><option key={o}>{o}</option>)}
                </select>
              </div>
              <div className="field"><label className="lbl">Raison invoquée</label>
                <select value={form.raison_invoquee} onChange={e=>set('raison_invoquee',e.target.value)}>{RAISONS.map(o=><option key={o}>{o}</option>)}</select>
              </div>
            </div>
            {form.raison_invoquee==='Autre'&&<div className="field"><label className="lbl">Précisez</label><input type="text" value={form.raison_invoquee_autre} onChange={e=>set('raison_invoquee_autre',e.target.value)} /></div>}
            <div style={{marginTop:'12px'}}>
              <div className="field"><label className="lbl">Plaintes précédentes</label></div>
              {plaintes.map((pl,i)=>(
                <div key={i} style={{display:'grid',gridTemplateColumns:'1fr 80px 1fr',gap:'8px',marginBottom:'8px',alignItems:'flex-end'}}>
                  <div className="field" style={{margin:0}}><label className="lbl" style={{fontSize:'10px'}}>Type</label>
                    <select value={pl.type_plainte} onChange={e=>setP(i,'type_plainte',e.target.value)}><option value="">Sélectionner…</option>{TYPES_PLAINTE.map(o=><option key={o}>{o}</option>)}</select>
                  </div>
                  <div className="field" style={{margin:0}}><label className="lbl" style={{fontSize:'10px'}}>Nombre</label><input type="number" min="0" value={pl.nombre} onChange={e=>setP(i,'nombre',e.target.value)} placeholder="0" /></div>
                  <div className="field" style={{margin:0}}><label className="lbl" style={{fontSize:'10px'}}>État</label>
                    <select value={pl.etat} onChange={e=>setP(i,'etat',e.target.value)}><option value="">Sélectionner…</option>{ETATS_PLAINTE.map(o=><option key={o}>{o}</option>)}</select>
                  </div>
                </div>
              ))}
              <button className="add-child" onClick={()=>setPlaintes(p=>[...p,{type_plainte:'',nombre:'',etat:''}])}>+ Ajouter une plainte</button>
            </div>
          </div>
          <div style={{background:'#e6f1fb',border:'1px solid #b5d4f4',borderRadius:'10px',padding:'16px',marginBottom:'16px'}}>
            <div style={{fontSize:'13px',fontWeight:'700',color:'#185fa5',marginBottom:'12px',textTransform:'uppercase'}}>Procédures contre le parent protecteur</div>
            <div className="col3">
              <div className="field"><label className="lbl">Nb de plaintes</label><input type="number" min="0" value={form.nb_plaintes_pp} onChange={e=>set('nb_plaintes_pp',e.target.value)} placeholder="0" /></div>
              <div className="field"><label className="lbl">Nb de condamnations</label><input type="number" min="0" value={form.nb_condamnations_pp} onChange={e=>set('nb_condamnations_pp',e.target.value)} placeholder="0" /></div>
              <div className="field"><label className="lbl">État actuel</label>
                <select value={form.etat_plainte_pp} onChange={e=>set('etat_plainte_pp',e.target.value)}><option value="">Sélectionner…</option>{ETATS_PLAINTE.map(o=><option key={o}>{o}</option>)}</select>
              </div>
            </div>
          </div>
          <div className="col2">
            <div className="field"><label className="lbl">Coût juridique (€)</label><input type="number" value={form.cout_financier} onChange={e=>set('cout_financier',e.target.value)} placeholder="ex. 15000" /></div>
            <div className="field"><label className="lbl">Coût médical (€)</label><input type="number" value={form.cout_medical} onChange={e=>set('cout_medical',e.target.value)} placeholder="ex. 3000" /></div>
          </div>
          <div className="field"><label className="lbl">Coût professionnel et social (€)</label><input type="number" value={form.cout_professionnel} onChange={e=>set('cout_professionnel',e.target.value)} placeholder="ex. 8000" /></div>
          <Toggle value={form.parole_enfant_seulement} onChange={v=>set('parole_enfant_seulement',v)} label="Nous n'avons que la parole de l'enfant comme preuve" />
          <div className="field"><label className="lbl">Remarques libres</label><textarea value={form.remarque_procedure} onChange={e=>set('remarque_procedure',e.target.value)} placeholder="Initiales uniquement pour les noms…" /></div>
          <div className="nav-btns"><SaveBtn /><div style={{display:'flex',gap:'8px'}}><button className="btn-prev" onClick={()=>setStep(4)}>← Précédent</button><button className="btn-next" onClick={()=>setStep(6)}>Suivant →</button></div></div>
        </div>

        {/* ÉTAPE 7 */}
        <div className={`step-block${step===6?' show':''}`}>
          <div className="step-title">Données du dossier</div>
          <div className="edith-form">
            <div className="edith-form-t">Pour le rapport institutionnel</div>
            <div className="edith-form-s">Aucun champ n'est obligatoire ici.</div>
            <div className="col2">
              <div className="field"><label className="lbl">Preuves déposées</label><input type="number" min="0" value={form.nb_preuves} onChange={e=>set('nb_preuves',e.target.value)} placeholder="0" /></div>
              <div className="field"><label className="lbl">Personnes ayant protégé</label><input type="number" min="0" value={form.nb_personnes_protectrices} onChange={e=>set('nb_personnes_protectrices',e.target.value)} placeholder="0" /></div>
            </div>
            <div className="col3">
              <div className="field"><label className="lbl">Magistrats ayant traité</label><input type="number" min="0" value={form.nb_magistrats} onChange={e=>set('nb_magistrats',e.target.value)} placeholder="0" /></div>
              <div className="field"><label className="lbl">Agents ASE</label><input type="number" min="0" value={form.nb_agents_ase} onChange={e=>set('nb_agents_ase',e.target.value)} placeholder="0" /></div>
              <div className="field"><label className="lbl">Dossier perdu</label><input type="number" min="0" value={form.nb_dossier_perdu} onChange={e=>set('nb_dossier_perdu',e.target.value)} placeholder="0" /></div>
            </div>
            <div className="col3">
              <div className="field"><label className="lbl">Jugements rendus</label><input type="number" min="0" value={form.nb_jugements} onChange={e=>set('nb_jugements',e.target.value)} placeholder="0" /></div>
              <div className="field"><label className="lbl">Dysfonctionnements</label><input type="number" min="0" value={form.nb_dysfonctionnements} onChange={e=>set('nb_dysfonctionnements',e.target.value)} placeholder="0" /></div>
              <div className="field"><label className="lbl">Fois où l'enfant a parlé</label><input type="number" min="0" value={form.nb_enfant_a_parle} onChange={e=>set('nb_enfant_a_parle',e.target.value)} placeholder="0" /></div>
            </div>
          </div>
          <div className="nav-btns"><SaveBtn /><div style={{display:'flex',gap:'8px'}}><button className="btn-prev" onClick={()=>setStep(5)}>← Précédent</button><button className="btn-next" onClick={()=>setStep(7)}>Suivant →</button></div></div>
        </div>

        {/* ÉTAPE 8 */}
        <div className={`step-block${step===7?' show':''}`}>
          <div className="step-title">Témoignage & Actions</div>
          <ANON />
          <div className="field"><textarea value={form.temoignage} onChange={e=>set('temoignage',e.target.value)} placeholder="Racontez votre situation — initiales uniquement…" style={{height:'140px'}} /></div>
          <div style={{background:'#f4f6fb',borderRadius:'10px',padding:'16px',marginBottom:'16px',border:'1px solid #dde3f0'}}>
            <div style={{fontSize:'13px',fontWeight:'700',marginBottom:'14px',color:'#0a1f44',textTransform:'uppercase'}}>Actions collectives</div>
            <Toggle value={form.action_anonyme_collectif} onChange={v=>set('action_anonyme_collectif',v)} label="Participer anonymement à des demandes collectives (état, ONU, commission européenne…)" />
            <Toggle value={form.action_nominatif_collectif} onChange={v=>set('action_nominatif_collectif',v)} label="Participer nommément à des demandes collectives auprès des institutions publiques" />
            <Toggle value={form.action_collectif_contact} onChange={v=>set('action_collectif_contact',v)} label="Être contactée par le collectif Juste Ensemble pour d'autres actions" />
            <Toggle value={form.temoignage_journaliste_anon} onChange={v=>set('temoignage_journaliste_anon',v)} label="Témoigner anonymement auprès de journalistes" />
            <Toggle value={form.temoignage_journaliste_nominatif} onChange={v=>set('temoignage_journaliste_nominatif',v)} label="Témoigner nommément auprès de journalistes" />
          </div>
          <div style={{paddingTop:'16px',borderTop:'1px solid #dde3f0'}}>
            <Toggle value={form.cgu_acceptees} onChange={v=>set('cgu_acceptees',v)} label={<span>J'ai lu et j'accepte les <span style={{color:'#1a7fd4',cursor:'pointer',textDecoration:'underline'}} onClick={()=>window.open('/cgu','_blank')}>CGU</span></span>} />
          </div>
          {error && <div className="note">{error}</div>}
          <div className="nav-btns">
            <div style={{display:'flex',gap:'8px'}}><button className="btn-prev" onClick={()=>setStep(6)}>← Précédent</button><SaveBtn /></div>
            <button className="btn-submit" onClick={submit} disabled={submitting||!form.cgu_acceptees} style={{opacity:form.cgu_acceptees?1:0.5}}>
              {submitting?'Envoi…':'Envoyer mon dossier →'}
            </button>
          </div>
          <div style={{marginTop:'20px',padding:'16px',background:'#f4f6fb',borderRadius:'8px',textAlign:'center',fontSize:'13px',color:'#666',lineHeight:'1.7'}}>
            Votre dossier sera <strong>publié après relecture de notre équipe bénévole</strong>.<br/>
            Prévoyez <strong>48 à 72h</strong> avant notre retour par mail.
          </div>
        </div>
      </div>
    </div>
  );
}

export default function MonCompte({ onBack, onDeposer }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [fiches, setFiches] = useState([]);
  const [draft, setDraft] = useState(null);
  const [loading, setLoading] = useState(true);
  const [authLoading, setAuthLoading] = useState(true);
  const [view, setView] = useState('dashboard');
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    // D'abord écouter les changements (capte le magic link)
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setAuthLoading(false);
      if (session?.user) { setUser(session.user); setToken(session.access_token); loadData(session.access_token); }
      else { setUser(null); setToken(null); setFiches([]); setDraft(null); setLoading(false); }
    });
    // Puis vérifier si session existante
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session?.user) { setUser(session.user); setToken(session.access_token); loadData(session.access_token); }
      setAuthLoading(false);
    });
    return () => subscription.unsubscribe();
  }, []);

  const loadData = async (tok) => {
    setLoading(true);
    try {
      const headers = { Authorization: 'Bearer ' + tok };
      const [fichesRes, draftRes] = await Promise.all([
        axios.get(API + '/api/mes-fiches', { headers }),
        axios.get(API + '/api/fiches/draft', { headers }).catch(() => ({ data: null }))
      ]);
      setFiches(fichesRes.data || []);
      setDraft(draftRes.data || null);
    } catch(e) {}
    setLoading(false);
  };

  const logout = async () => { await supabase.auth.signOut(); setUser(null); setToken(null); };

  if (authLoading) return <div style={{textAlign:'center',padding:'80px',color:'#888',fontSize:'14px'}}>Connexion en cours…</div>;

  if (!user) return (
    <div style={{maxWidth:'400px',margin:'80px auto',padding:'0 24px'}}>
      <span style={{fontSize:'12px',color:'#888',cursor:'pointer',marginBottom:'24px',display:'inline-block'}} onClick={onBack}>← Retour</span>
      <h2 style={{fontSize:'22px',fontWeight:'800',color:'#0a1f44',textTransform:'uppercase',marginBottom:'8px'}}>Mon espace</h2>
      <p style={{fontSize:'13px',color:'#666',lineHeight:'1.65',marginBottom:'24px'}}>Accédez à vos dossiers, reprenez un dépôt en cours ou suivez l'état de votre dossier.</p>
      <MagicLinkForm />
    </div>
  );

  if (submitted) return (
    <div style={{maxWidth:'600px',margin:'80px auto',textAlign:'center',padding:'0 24px'}}>
      <div style={{fontSize:'48px',marginBottom:'16px'}}>✓</div>
      <h3 style={{fontSize:'20px',fontWeight:'800',color:'#0a1f44',marginBottom:'12px',textTransform:'uppercase'}}>Dossier envoyé</h3>
      <p style={{color:'#555',lineHeight:'1.7',marginBottom:'24px'}}>Votre dossier sera publié après relecture de notre équipe bénévole. Prévoyez 48 à 72h.</p>
      <button className="btn-blue" onClick={()=>{setSubmitted(false);setView('dashboard');loadData(token);}}>Retour à mon espace</button>
    </div>
  );

  if (view === 'form') return (
    <div style={{maxWidth:'720px',margin:'0 auto',padding:'28px 24px 60px'}}>
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:'20px'}}>
        <span style={{fontSize:'12px',color:'#888',cursor:'pointer'}} onClick={()=>setView('dashboard')}>← Mon espace</span>
        <span style={{fontSize:'12px',color:'#888'}}>{user.email}</span>
      </div>
      <div style={{background:'#0a1f44',borderRadius:'12px',padding:'20px 24px',marginBottom:'24px'}}>
        <div style={{fontSize:'10px',letterSpacing:'0.1em',color:'#4db3ff',fontWeight:'600',marginBottom:'6px',textTransform:'uppercase'}}>Mon dossier</div>
        <div style={{color:'#fff',fontSize:'16px',fontWeight:'700'}}>Renseignez et sauvegardez votre situation à votre rythme.</div>
      </div>
      <DossierForm token={token} userId={user.id} draft={draft} onSubmitted={()=>setSubmitted(true)} />
    </div>
  );

  return (
    <div style={{maxWidth:'680px',margin:'0 auto',padding:'36px 24px 60px'}}>
      <span style={{fontSize:'12px',color:'#888',cursor:'pointer',marginBottom:'24px',display:'inline-block'}} onClick={onBack}>← Retour</span>
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:'28px'}}>
        <div>
          <h2 style={{fontSize:'22px',fontWeight:'800',color:'#0a1f44',textTransform:'uppercase',marginBottom:'4px'}}>Mon espace</h2>
          <div style={{fontSize:'13px',color:'#888'}}>{user.email}</div>
        </div>
        <button onClick={logout} style={{background:'transparent',border:'1px solid #dde3f0',borderRadius:'6px',padding:'6px 14px',fontSize:'12px',color:'#666',cursor:'pointer'}}>Se déconnecter</button>
      </div>

      {loading ? <div style={{textAlign:'center',padding:'40px',color:'#888'}}>Chargement…</div> : (
        <div>
          {draft ? (
            <div style={{background:'#e6f1fb',border:'1px solid #b5d4f4',borderRadius:'12px',padding:'20px',marginBottom:'20px',display:'flex',alignItems:'center',justifyContent:'space-between',gap:'16px',flexWrap:'wrap'}}>
              <div>
                <div style={{fontSize:'14px',fontWeight:'700',color:'#0a1f44',marginBottom:'4px'}}>Brouillon en cours</div>
                <div style={{fontSize:'12px',color:'#666'}}>Dernière sauvegarde : {new Date(draft.created_at).toLocaleDateString('fr-FR')}</div>
              </div>
              <button className="btn-blue" style={{fontSize:'13px',padding:'9px 20px',whiteSpace:'nowrap'}} onClick={()=>setView('form')}>
                Reprendre mon dossier →
              </button>
            </div>
          ) : (
            <div style={{background:'#f4f6fb',borderRadius:'12px',padding:'24px',marginBottom:'20px',textAlign:'center'}}>
              <div style={{fontSize:'14px',color:'#666',marginBottom:'16px'}}>Vous n'avez pas encore commencé de dossier.</div>
              <button className="btn-blue" onClick={()=>setView('form')}>Commencer mon dossier</button>
            </div>
          )}

          {fiches.filter(f=>f.statut!=='brouillon').length > 0 && (
            <div>
              <div style={{fontSize:'13px',fontWeight:'700',color:'#0a1f44',textTransform:'uppercase',marginBottom:'14px'}}>
                Mes dossiers soumis ({fiches.filter(f=>f.statut!=='brouillon').length})
              </div>
              {fiches.filter(f=>f.statut!=='brouillon').map(f=>(
                <div key={f.id} style={{background:'#fff',border:'1px solid #dde3f0',borderRadius:'12px',padding:'16px',marginBottom:'12px'}}>
                  <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:'8px'}}>
                    <div>
                      <div style={{fontSize:'13px',fontWeight:'700',color:'#0a1f44'}}>{f.tribunal?'JAF '+f.tribunal:'Dossier'}{f.departement?' · '+f.departement:''}</div>
                      <div style={{fontSize:'11px',color:'#aaa',marginTop:'2px'}}>{new Date(f.created_at).toLocaleDateString('fr-FR')}</div>
                    </div>
                    <span style={{fontSize:'10px',padding:'3px 10px',borderRadius:'4px',fontWeight:'700',
                      background:f.statut==='publiee'?'#d1fae5':f.statut==='rejetee'?'#fee2e2':'#e6f1fb',
                      color:f.statut==='publiee'?'#065f46':f.statut==='rejetee'?'#991b1b':'#185fa5'}}>
                      {f.statut==='publiee'?'Publié':f.statut==='rejetee'?'Refusé':'En attente'}
                    </span>
                  </div>
                  {f.type_violences?.length>0&&<div style={{display:'flex',gap:'6px',flexWrap:'wrap'}}>
                    {f.type_violences.map(v=><span key={v} style={{fontSize:'10px',padding:'2px 7px',borderRadius:'3px',background:'#e6f1fb',color:'#1a7fd4',fontWeight:'600'}}>{v}</span>)}
                  </div>}
                </div>
              ))}
            </div>
          )}

          {draft && <button className="btn-blue" onClick={()=>setView('form')} style={{marginTop:'8px'}}>+ Modifier mon dossier</button>}
        </div>
      )}
    </div>
  );
}
